import React, { FC } from 'react'
import Card from 'components/base/Card'
import Icon from 'project/Icon'
import { useDefaultSubscription } from 'common/services/useDefaultSubscription'
import { kycNeedsVerifying } from 'common/services/useKycStatus'
import Link from 'next/link'
import CardTitle from './CardTitle'
import useRequiresKYC from 'common/useRequiresKYC'

type AccountStatusCardType = {
  className?: string
}

const AccountStatusCard: FC<AccountStatusCardType> = ({ className }) => {
  const { subscriptionDetail } = useDefaultSubscription()
  const kyc = subscriptionDetail?.kyc_status
  const needsVerify = kycNeedsVerifying(subscriptionDetail)
  const requiresKyc = useRequiresKYC()

  if (!requiresKyc) {
    return null
  }
  if (!needsVerify) return null
  return (
    <div className={className}>
      <Card>
        <div className='flex-fill'>
          <CardTitle title={'YOUR ACCOUNT'} subtitle={'Account Status'} />
          <div className='flex-row mt-2 mb-1 align-items-center'>
            <Icon fill='danger' name='error' />

            <h3 className='mb-0 ms-1 text-danger900'>Not Verified</h3>
          </div>
          <span className='my-2 fs-lg d-block pb-3'>
            One or more of the officers associated with your company needs to
            provide proof of identity.
          </span>
        </div>
        {kyc?.kyc_link ? (
          <a
            href={kyc?.kyc_link}
            target='_blank'
            className='btn w-100 btn-primary'
            rel='noreferrer'
          >
            Verify
          </a>
        ) : (
          <Link
            href={'/settings?tab=business#business-owners'}
            className='btn w-100 btn-primary'
            rel='noreferrer'
          >
            Verify
          </Link>
        )}
      </Card>
    </div>
  )
}
export default AccountStatusCard
